

export default {
  referral: {
    refProgrram: "Referral program",
    refAFr: "Refer-A-Friend",
    inviteFr: "Invite Friends & Get 15€ for their Order",
    copy: "Copy your personal invite link",
    or: "or",
    inviteEmail: "Invite via email",
    invite: "Invite",
    balance: "Balance",
    yourBalance: "Your balance is",
    spend: "You can spend it to pay for Lappa services",
    invitations: "Your Invitations",
    email: "Email",
    status: "Status",
    invSent: "Your invitation was sent successfully",
    noRef: `You don't have any referrals`,
  },
  noDataMessage: {
    nothingToShowHere: "Nothing to show here yet!",
  },
  datepicker: {
    dateRange: "Date range:",
    cancel: "Cancel",
    apply: "Apply",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    periodFrom: "From",
    periodTo: "To",
    startDate: "Start date",
    endDate: "End date",
    periodNotChosen: "—",
    rangeOrDateToggle: "Date range / Date",
    selectedStartDate: "Selected start date",
    selectedEndDate: "Selected end date",
    suggestedStartDate: "Suggested start date",
    suggestedEndDate: "Suggested end date",
    year: "Year",
    clear: "Clear",
    reset: "Reset",
    applyFilter: "Apply filter",
    chooseYear: "Choose year",
    prevYear: "Previous years",
    nextYear: "Next years",
  },
  userGuide: {
    goToUserGuide: "Go to user guide",
    completed1: "1 of 4 tasks completed!",
    completed1_desc:
      "That's it! Your profile is filled & ready. Go to user guide to continue setting everything up!",
    completed2: "2 of 4 tasks completed!!",
    completed2_desc:
      "That's it! Your store is successfully added. Go to user guide to continue setting everything up! ",
    completed3: "3 of 4 tasks completed!!",
    completed3_desc:
      "That's it! Your sales tax permit is successfully added. Go to user guide to finish setting everything up!",
    completed4: "4 of 4 tasks completed!!",
    completed4_desc:
      "That's it! Transaction is successfully added. Congratulations on settings everything up!",
  },
  modalWelcomeToLovat: {
    title: "Welcome to Lappa",
    textOneLine:
      "Congratulations on joining Lappa, your gateway to stress-free tax compliance for online selling.",
    textTwoLine: "We're thrilled to have you on board! 🎉",
    textThereLine:
      "Book a demo with a Lappa expert to see how the platform works and get all your questions answered",
    textThereLineLink: "here.",
    textFourLine:
      "Experience a 14-day free trial or secure your subscription plan today.",
    buttonPrimary: "Try free for 14 days",
    or: "or",
    purchaseNow: "purchase now",
  },
};
